<template lang="pug">
.container.grid-lg.py-2
  .pb-2
    .toast Assuntos de outros departamentos para criar OS-m informativa.
  .form-group
    input.form-input(v-model.trim='search' placeholder='Pesquisar')
  load-manager(:status='status')
    list-manager(:status='status', :count='list.length')
      .mb-2.pb-2(v-for="assunto in assuntos")
        .card
          .card-body
            .pb-2
              .h5.text-primary {{ assunto.descricao }}
            .card-title.h6 {{ assunto.departamento.diretoria.secretaria.sigla }} - {{ assunto.departamento.diretoria.secretaria.nome }}
            .card-subtitle.text-gray.text-small {{ assunto.departamento.diretoria.nome }}
            .card-subtitle.text-gray {{ assunto.departamento.nome }}
          .card-footer.text-right
            router-link.btn.btn-link(:to="{ name: 'app.osm.compartilhado.servicos.new', params: { assunto_id: assunto.id } }")
              btn-content(name='new' label='Nova OS-m')
</template>

<script>
import transliterate from '@/lib/transliterate'
import { deepKey } from 'paliari-js-utils'

export default {
  vuex: {
    'compartilhado/assuntos': {
      state: ['list', 'status'],
      getters: ['loading'],
      actions: ['fetchList'],
    },
  },

  data() {
    return {
      search: '',
    }
  },

  methods: {
    show(text) {
      if (!this.search) return true
      const exp = new RegExp(
        transliterate(this.search)
          .split(' ')
          .join('.*'),
        'g',
      )

      return exp.test(transliterate(text))
    },
  },

  computed: {
    assuntos() {
      if (!this.list) return []
      const searchKeys = [
        'departamento.diretoria.secretaria.sigla',
        'departamento.diretoria.secretaria.nome',
        'departamento.diretoria.nome',
        'departamento.nome',
        'descricao',
      ]

      return this.list.filter(a => {
        const text = searchKeys.map(k => deepKey(a, k)).join(' ')

        return this.show(text)
      })
    },
  },

  created() {
    if (!this.list || this.list.length === 0) {
      this.fetchList()
    }
  },
}
</script>
